import React from "react";
import Header from "../components/Header/Header";
import Footer from "../components/Footer/Footer";
import './Common.css';

const PrivacyPolicy = () => {
    return (
        <>
            <Header />
            <div className="mainhadding">
                <ul>
                <h1>PRIVACY POLICY</h1>
                <li>
                    We may amend these terms and conditions from time to time, for which you will be notified by via email address which you provided at time of registration or by announcing such amendments at our website sbstorefsd.com.
                </li>
                <li>
                    By accessing our website you confirm to have understood and agreed to our privacy policy and term and conditions.
                </li>
                <li>
                    We collect information about you when your visit our website and other sites accessible from the website. When you take part in surveys conducted by us, participate in any promotion run by us and when you place any order on our website.
                </li>
                <li>
                The purpose of collection of this information is to ensure that we understand your shopping needs and patterns, operate your account in more efficient manners, improve our service, Improve our websites, organize promotions and surveys.
                </li>
                <li>
                With your consent, we may send to you, from time to time, information related to new products, competitions, surveys and changes in our websites.
                </li>
                <li>
                We make every effort to keep your personal data and information safe and this is never disclosed to outside companies for their marketing purposes.
                </li>
                <li>
                sbstorefsd.com
                </li>
                </ul>
            </div>
            <Footer />
        </>
    )
}

export default PrivacyPolicy;